import { Link } from "react-router-dom";
import { Mail, MapPin, Phone } from "lucide-react";

import { LANDING_SERVICES } from "@/components/landing/services";

export const SiteFooter = () => (
  <footer
    data-testid="site-footer"
    className="mt-20 border-t border-border bg-[color:var(--tt-surface-2)]"
  >
    <div className="mx-auto max-w-6xl px-4 py-14 sm:px-6">
      <div className="grid grid-cols-1 gap-10 sm:grid-cols-2">
        <div>
          <h3 className="text-sm font-semibold uppercase tracking-[0.12em] text-primary">
            Get in touch
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li className="flex items-start gap-3">
              <Phone className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
              <a
                href="tel:+27817882993"
                data-testid="site-footer-contact-phone"
                className="hover:text-primary"
              >
                +27 81 788 2993
              </a>
            </li>
            <li className="flex items-start gap-3">
              <Mail className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
              <a
                href="mailto:info@t-tite.co.za"
                data-testid="site-footer-contact-email"
                className="hover:text-primary"
              >
                info@t-tite.co.za
              </a>
            </li>
            <li className="flex items-start gap-3" data-testid="site-footer-contact-address">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" aria-hidden="true" />
              <span>
                48 Chrisoliet, Jukskei Park
                <br />
                Randburg, 2188
              </span>
            </li>
          </ul>
        </div>

        <div>
          <h3 className="text-sm font-semibold uppercase tracking-[0.12em] text-primary">
            Quick links
          </h3>
          <ul className="mt-4 space-y-3 text-sm text-muted-foreground">
            <li>
              <Link to="/pricing-calculator" className="hover:text-primary">
                Pricing calculator
              </Link>
            </li>
            {LANDING_SERVICES.map(({ slug, path, label }) => (
              <li key={slug}>
                <Link
                  to={path}
                  data-testid={`site-footer-service-${slug}`}
                  className="hover:text-primary"
                >
                  {label}
                </Link>
              </li>
            ))}
            <li>
              <Link
                to="/verify-quote"
                data-testid="site-footer-verify-link"
                className="hover:text-primary"
              >
                Verify a quote
              </Link>
            </li>
            <li>
              <a href="https://www.t-tite.co.za/contact-us/" className="hover:text-primary">
                Contact us
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="mt-12 border-t border-border pt-6">
        <p className="text-xs font-semibold uppercase tracking-[0.12em] text-muted-foreground">
          Professional Bodies and Affiliations
        </p>
        <div className="mt-3 flex flex-wrap gap-x-6 gap-y-2 text-xs text-muted-foreground">
          <span data-testid="site-footer-body-irba">IRBA — Registered Auditors</span>
          <span data-testid="site-footer-body-saica">SAICA</span>
        </div>
        <p className="mt-6 text-xs text-muted-foreground">
          ©Copyright T-tite Accounting Services 2024. Information you submit here is used only to
          prepare and discuss your quote, and is never sold or shared with third parties (POPIA).
        </p>
      </div>
    </div>
  </footer>
);
